import $ from '/js/header/jquery.js';

$(() => {
    list();
    $(".tab_menu ul .tab_9:first").addClass("on");
    $(".tab_menu ul .tab_9").on("click", (e) => {
        $("#category").val($(e.currentTarget).data('code'));
        $(".tab_menu ul .tab_9").removeClass("on");
        $(e.currentTarget).addClass("on");
        list();
    });
});

function list() {
    let html = "";
    $.ajax(
        {
            type: "POST",
            url: "/study/res/Study.php",
            data: $("#fmSTD").serialize(),
            dataType: "JSON",
            success: function (data) {
                let category = data.category;
                var num = 0;
                html += `
                <div class='group_list scroll_w' style='margin:0px'>
                    <div id='auct'>
                        <table class='tbl_grid' id='link_doc'>`
                $.each(data.items, (key, item) => {
                    num++;
                    html += `
                            <tr class='preview' height='50' id='tr_${num}' data-num=${num} data-category=${category} data-title='${item.title}'">
                                <td style='padding-left:15px'>
                                    <span class='f16'>${item.title}</span>
                                </td>
                            </tr>
                    `;
                });
                html += `
                        </table>
                        <br>
                    </div>
                </div>
                <div class='group_view'>
                    <div class='area_btns'>
                        <span class='downMent no-mobile' style='padding-right:15px'> 오른쪽 항목 클릭 후 인쇄 및 다운 받으세요~</span>
                        <a href=\"javascript:alert('오른쪽 항목 클릭 후 인쇄 및 다운 받으세요')\" id='lnkDoc'>
                            <span class='button btn_dooin btn_small'>MS워드</span>
                        </a>
                        <a href=\"javascript:alert('오른쪽 항목 클릭 후 인쇄 및 다운 받으세요')\" id='lnkHwp'>
                            <span class='button btn_dooin btn_small'>한글워드</span>
                        </a>
                    </div>
                    <div class='area_view'><div id='pdfDoc'><img src='/image/common/form_guide.png'></div>
                </div>`;
                $("#ltTbody").html(html);

                // 미리보기 클릭 이벤트
                $(".tbl_grid .preview").on("click", (e) => {
                    let num = $(e.currentTarget).data('num');
                    let ctNo = $(e.currentTarget).data('category');
                    let str = $(e.currentTarget).data('title');
                    preview(num, ctNo, str);
                });
            }
        });
}

function preview(num, ctNo, str) {
    $("#pdfDoc").html(`<iframe frameborder='0' style='border:0px solid #000' width='100%' height='703px' marginheight='0' marginwidth='0' scrolling='no' src='/api/pdf/web/pdf.php?file=/FILEINC/FORM/docu_form/category_${ctNo}/${str}.pdf'></iframe>`);
    $(".group_view .area_btns .downMent").css({"display": "none"});
    $('.tbl_grid tr').removeClass('on');
    $(`#tr_${num}`).addClass('on');
    $("#lnkDoc").attr("href", `/res/download.php?mode=docu_form&ctNo=${ctNo}&file_name=${str}.doc`);
    $("#lnkHwp").attr("href", `/res/download.php?mode=docu_form&ctNo=${ctNo}&file_name=${str}.hwp`);
    // group_view 영역으로 스크롤 이동
    $('html, body').animate({
        scrollTop: $(".group_view").offset().top - 100
    }, 500);
}